import {useQuery} from 'react-query'
import {QUERIES} from '../../../../_metronic/helpers'
import {useAuth} from '../../auth'
import {getConfigById} from '../components/configs-list/core/_requests'

/**
 * Hook para verificar se o usuário atual pode editar a descrição de uma tarefa.
 *
 * Regra:
 * - Se limit_task_description_editing estiver desativado (padrão): todos podem editar
 * - Se estiver ativado: somente gestor, administrador ou criador da tarefa podem editar
 */
export function useCanEditTaskDescription(task?: {creator_id?: string | number}) {
  const {currentUser} = useAuth()
  const instanceId = currentUser?.instance_id

  const {data: config, isLoading} = useQuery(
    `${QUERIES.PROJECTS_LIST}-config-${instanceId}`,
    () => {
      if (!instanceId) return null
      return getConfigById(instanceId)
    },
    {
      enabled: !!instanceId,
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  )

  // Se não há configuração ou está carregando, mantém comportamento atual (permitir)
  if (isLoading || !config?.data) {
    return {canEditDescription: true, isLoading: true, config: config?.data}
  }

  const limitTaskDescriptionEditing = config.data.limit_task_description_editing || false

  if (!limitTaskDescriptionEditing) {
    return {canEditDescription: true, isLoading: false, config: config.data}
  }

  const isManager = Boolean(currentUser?.manager)
  const isAdmin = Boolean(currentUser?.administrator)
  if (isManager || isAdmin) {
    return {canEditDescription: true, isLoading: false, config: config.data}
  }

  if (task?.creator_id) {
    const currentUserId = currentUser?.id
    const taskCreatorId =
      typeof task.creator_id === 'string' ? parseInt(task.creator_id) : task.creator_id
    const isCreator = currentUserId === taskCreatorId
    return {canEditDescription: isCreator, isLoading: false, config: config.data}
  }

  return {canEditDescription: false, isLoading: false, config: config.data}
}

